import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "It appears that seeking transfer advice may be an option worth considering")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " If you wish to consider a transfer further, you can seek advice from any of the specialist advisers shown on our panel by clicking the transfer advisers button below. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " The advice process of these experienced advisers is continually monitored to ensure that it is clear to understand and of a level the FCA would expect from advisers. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you wish to seek transfer advice from elsewhere")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Alternatively, if you wish to choose an alternative transfer adviser you can visit the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.moneyhelper.org.uk/en",
    target: "_blank"
  }, "MoneyHelper"),
  /*#__PURE__*/_createTextVNode(" site for further guidance and signposting to an adviser. If you choose this route, please visit the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.fca.org.uk/scamsmart",
    target: "_blank"
  }, "FCA's scamsmart website"),
  /*#__PURE__*/_createTextVNode(" to ensure you understand how potential scams may occur. Alternatively "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/watch?v=TYk_X3tn9hc",
    target: "_blank"
  }, "watch this video on avoiding scams"),
  /*#__PURE__*/_createTextVNode(" from our friends at Quietroom. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you wish to seek advice on a potential transfer")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " If you wish to consider a transfer further, please click the button below. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_buttons = _resolveComponent("nav-buttons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.showGuiide)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_nav_buttons, {
            previousVisible: false,
            nextVisible: true,
            nextText: "Transfer Advisors",
            onNextClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-transfer-advisors-required')))
          }),
          _hoisted_4,
          _hoisted_5
        ], 64))
      : _createCommentVNode("", true),
    ($options.showOrigen)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_nav_buttons, {
            previousVisible: false,
            nextVisible: true,
            nextText: "Transfer Advice",
            onNextClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-transfer-advisors-required')))
          })
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}